var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.appConfig.env !== 'prod')?_c('strong',{staticClass:"preview_development"},[_vm._v("Environnement de recette")]):_vm._e(),_c(_vm.resolveLayout,{tag:"component"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }